

module.exports = function($scope) {
  var vm = this;

  vm.answers = {};

  vm.submit = function() {
    $scope.confirm({ action: "submit", answers: vm.answers });
  };

};
